import { FC } from "react";
import clsx from "clsx";
import { Link } from "react-router-dom";
import { useLocation } from "react-router";
import { checkIsActive, WithChildren } from "../../../../../_metronic/helpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/pro-light-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { MenuItem } from "react-pro-sidebar";

type AsideMenuItemProps = {
  to: string;
  title: string;
  icon?: IconDefinition;
  hasBullet?: boolean;
  externalLink?: boolean;
  onClick?: (e: React.MouseEvent) => void;
  "data-test-id"?: string;
};

type AsideMenuItemLinkLinkProps = {
  to: string;
  externalLink?: boolean;
  onClick?: (e: React.MouseEvent) => void;
  "data-test-id"?: string;
};

const AsideMenuItem: FC<AsideMenuItemProps> = ({
  to,
  title,
  icon,
  hasBullet = false,
  externalLink = false,
  onClick,
  "data-test-id": testId,
}) => {
  const { pathname } = useLocation();
  const isActive = checkIsActive(pathname, to);

  return (
    <MenuItem
      icon={
        <FontAwesomeIcon
          icon={icon! as IconProp}
          size="lg"
          style={{ color: isActive ? "var($cpl-secondary)" : "var($cpl-primary)" }}
        />
      }
      suffix={
        hasBullet && (
          <span className="menu-bullet">
            <span className="bullet bullet-dot"></span>
          </span>
        )
      }
      component={<AsideMenuItemLink to={to} externalLink={externalLink} onClick={onClick} />}
      data-test-id={testId}
    >
      {title}
    </MenuItem>
  );
};

const AsideMenuItemLink: FC<AsideMenuItemLinkLinkProps & WithChildren> = ({
  children,
  to,
  externalLink = false,
  onClick,
  "data-test-id": testId,
}) => {
  const { pathname } = useLocation();
  const isActive = checkIsActive(pathname, to);
  const cssClasses = clsx("menu-link ps-6 px-4 py-2", { active: isActive });

  if (externalLink) {
    return (
      <a className={cssClasses} href={to} target="_blank" rel="noreferrer" onClick={onClick} data-test-id={testId}>
        {children}
      </a>
    );
  } else {
    return (
      <Link className={cssClasses} to={to} onClick={onClick} data-test-id={testId}>
        {children}
      </Link>
    );
  }
};

export { AsideMenuItem };
